import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import SubscriptionsStatusPage from "@/components/settings/billing/subscriptions-status-page";

const WorkspaceSubscriptionsPage = (): JSX.Element => <SubscriptionsStatusPage />;

export const Route = createFileRoute("/_app/settings/workspace/subscriptions/")({
	component: WorkspaceSubscriptionsPage,
});
